export default __webpack_public_path__ + "static/media/rastech-1402.83542cfd.jpg";